import { api } from './api';
import type { AxiosError } from 'axios';
import { createEnhancedError } from '../utils/error-handling';

export interface PlanUsageStats {
  planTier: string;
  properties: {
    used: number;
    max: number;
  };
  storage: {
    usedBytes: number;
    maxBytes: number;
  };
}

const handleBillingError = (error: AxiosError): never => {
  throw createEnhancedError(error);
};

export interface Invoice {
  id: string;
  number: string;
  amountPaid: number;
  currency: string;
  status: string;
  hostedInvoiceUrl?: string;
  invoicePdf?: string;
  created: string;
}

export const billingApi = {
  getUsage: async (): Promise<PlanUsageStats> => {
    try {
      const response = await api.get<PlanUsageStats>('/billing/usage');
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      throw new Error('Failed to fetch plan usage');
    } catch (error) {
      return handleBillingError(error as AxiosError);
    }
  },

  getInvoices: async (): Promise<Invoice[]> => {
    try {
      const response = await api.get<any>('/billing/invoices');
      if (response.data?.success && response.data?.data) {
        return response.data.data as Invoice[];
      }
      return [];
    } catch (error) {
      console.error('Failed to fetch invoices', error);
      return [];
    }
  },

  openPortalSession: async (): Promise<{ url: string }> => {
    const response = await api.post<any>('/billing/portal-session');
    if (response.data?.success && response.data?.data) {
      return response.data.data as { url: string };
    }
    throw new Error('Keine Portal-URL erhalten.');
  },

  cancelSubscription: async (): Promise<void> => {
    await api.post('/billing/cancel-subscription');
  },
};
